import React from "react"
import PropTypes from "prop-types"
import {
  FormErrorMessage,
  FormLabel,
  FormControl as ChakraFormControl,
  Input as ChakraInput,
  Textarea,
} from "@chakra-ui/react"
import merge from "lodash/merge"

const defaultStyles = {
  formGroup: {
    mt: "32px",
    width: "100%",
  },
  formLabel: {
    display: "inline-block",
    bg: "white",
    color: "rgba(0, 0, 0, 0.54)",
    fontSize: "12px",
    marginLeft: "10px",
    position: "absolute",
    lineHeight: "12px",
    top: "-6px",
    zIndex: "1000",
  },
  input: {
    borderColor: "#DCE0E5",
    height: "48px",
    borderRadius: "4px",
    fontSize: "14px",
    linHeight: "19px",
  },
  textarea: {
    rows: 5,
    borderColor: "#DCE0E5",
    fontSize: "14px",
    linHeight: "19px",
  },
}

const FormControl = ({
  label,
  name,
  type,
  required,
  onChange,
  value,
  hint,
  id,
  styles,
}) => {
  const handleOnChange = React.useCallback(
    e => {
      onChange(id, e.target.value)
    },
    [id, onChange]
  )
  const _styles = React.useMemo(
    () => merge({}, defaultStyles, styles),
    [styles]
  )
  const InputComponent = React.useMemo(
    () => (type === "textarea" ? Textarea : ChakraInput),
    [type]
  )
  const _sxInput = React.useMemo(
    () => (type === "textarea" ? _styles.textarea : _styles.input),
    [type, _styles]
  )

  return (
    <ChakraFormControl
      isRequired={required}
      sx={_styles.formGroup}
      isInvalid={hint}
    >
      <FormLabel sx={_styles.formLabel} htmlFor={name}>
        {label}
      </FormLabel>
      <InputComponent
        sx={_sxInput}
        value={value}
        type={name}
        name={name}
        required={required}
        onChange={handleOnChange}
      />
      {hint && (
        <FormErrorMessage
          sx={{
            position: "absolute",
            fontSize: "12px",
            lineHeight: "12px",
            mt: "4px",
          }}
        >
          {hint}
        </FormErrorMessage>
      )}
    </ChakraFormControl>
  )
}

FormControl.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  type: PropTypes.string,
  required: PropTypes.bool,
  onChange: PropTypes.func,
  value: PropTypes.string,
  hint: PropTypes.string,
  id: PropTypes.string,
  styles: PropTypes.object,
}

FormControl.defaultProps = {
  styles: {},
}

export default FormControl
